import { useMemo } from 'react';

import type { SearchInputMode } from '../types';

export type UseHintToShowProps = {
  mode: SearchInputMode;
  hints?: string[] | null;
  value?: string | null;
};

export const useHintToShow = ({
  mode,
  hints,
  value,
}: UseHintToShowProps): { hintToShow: string | null } => {
  return useMemo(() => {
    if (
      mode !== 'live' ||
      value == null ||
      hints == null ||
      value.length === 0
    ) {
      return { hintToShow: null };
    }

    const hint = hints.filter((hint) =>
      hint.toLowerCase().startsWith(value?.toLowerCase() ?? ''),
    )[0];

    return { hintToShow: hint?.length > 0 ? hint.slice(value.length) : null };
  }, [mode, hints, value]);
};
